import { FC } from "react"

import { getSanitizedHTML } from "../../utils"

interface SafeHTMLRendererProps {
  htmlContent: string
  className?: string
  isText?: boolean
}

const SafeHTMLRenderer: FC<SafeHTMLRendererProps> = ({
  htmlContent,
  className = "",
  isText = true
}) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: getSanitizedHTML(htmlContent, isText)
      }}
    />
  )
}

export default SafeHTMLRenderer
